import React from 'react';
import { PaginationControlProps } from '../../../utils/interfaces';

const PaginationControls = ({currentPage, setCurrentPage, itemsPerPage, setItemsPerPage, maxPages, formData}: PaginationControlProps) => {
  return (
    <div className="pagination-controls mt-3 d-flex justify-content-between align-items-center mb-0">
        <div className="d-flex justify-content-center flex-grow-1 gap-5">
            <button
                disabled={currentPage == 1}
                onClick={() => setCurrentPage(currentPage - 1)}
                className="btn btn-sm btn-primary"
                style={{
                    width: "3%",
                    height: "3%",
                    padding: "0px 0px",
                }}
            >
                &lt;
            </button>
            <span style={{}}>
                Showing {(currentPage - 1) * itemsPerPage} to {currentPage * itemsPerPage} out
                of {formData?.total_count || 0} entries
            </span>
            <button
                disabled={currentPage >= maxPages}
                onClick={() => setCurrentPage(currentPage + 1)}
                className="btn btn-sm btn-primary"
                style={{
                    width: "3%",
                    height: "3%",
                    padding: "0px 0px",
                }}
            >
                &gt;
            </button>
        </div>
        <div className="">
            <label htmlFor="itemsPerPageSelect">Items per page:</label>
            <select
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                className="form-select mb-4"
                id="itemsPerPageSelect"
                aria-label="Items per page select"
            >
                <option value={3}>3</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={150}>150</option>
                <option value={200}>200</option>
                <option value={250}>250</option>
            </select>
        </div>
    </div>
  )
};

export default PaginationControls;